<template>
	<div class="recharge_wrap1">
		
		<form class="form">
			<!-- 充值余额输入 -->
			<div class="recharge_wrap">
				<div class="form-cell">
					<div class="flex_bd">
						<input v-model.trim="data.money" class="inp" :placeholder="$t('invest.rechargeAmount')" />
					</div>
					<span class="unit">
						{{$t('utils.moneyMark')}}
					</span>
				</div>
				<div>
					<span>{{actualAmount}}</span>
				</div>
			</div>
			<!-- 请选择支付方式 -->
			<div class="recharge_fs">
				<div class="tit">
					{{$t('invest.paymentMethod')}}
				</div>
				<div class="recharge_cells">
					<div v-for="(v, k) in this.payment" :key="k" class="item">
						<div class="re_name">{{ v.name }}</div>
						<van-radio-group v-model="radio" direction="horizontal">
							<van-radio :name="k+1" @click="paymentsta(v)"></van-radio>
						</van-radio-group>
					</div>
				</div>
			</div>
		</form>
		<!-- 下一步 -->
		<div class="basic_btn sbtn" @click="submit">{{$t('invest.next')}}</div>
		<!-- 遮罩层 -->
		<van-overlay :show="show">
			<div class="wrapper">
				<van-loading size="24px" vertical>loading...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		CountDown,
		Checkbox,
		RadioGroup,
		Icon,
		Radio,
		Toast,
		Overlay,
		Loading,
		Dialog
	} from 'vant';
	import Fetch from '../../utils/fetch.js'
	import axios from 'axios';
import router from '../../router.js';
	Vue.use(CountDown).use(Checkbox).use(Icon).use(Toast).use(router).use(Overlay).use(RadioGroup).use(Radio).use(Loading);

	export default {
		name: "invest",
		data() {
			return {
				time: 0,
				eye: 1,
				balance: 0.00,
				data: {
					choose: '',
					channel: '',
					money: '',
					id: ''
				},
				payment: [],
				config: {},
				actualAmount: '',
				// 请求支付所需要的参数
				amount:{
					"amounts":"",
					"uid":"35295",
					"paycon":"",
					"pid":"",
				},
				//支付回调地址
				paydata:"",
				show:false,
				// 支付方式
				payment:"",
				selectedPayment:null,
				radio: '',
				paycon:"",
				// 支付链接
				paylink:"",
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			//进入充值页面请求用户余额
			start() {
				Fetch('/user/recharge', {
					...this.data
				}).then((r) => {
					this.balance = r.data.money;
					this.config = r.data;
					this.payment = r.data.payment; 
				});
			},
			// 支付请求
			fetchpay(){
				// 将支付数据发送到后端
				let url = `https://api.gxfcpay.top/api/user/${this.paylink}`;
				
				const newPays = ["OKPAY","OKEYPAY","JNHPAY","PPAY","QEPAY","GCTPK"];
				if(newPays.includes(this.selectedPayment.qrcode)){
					this.amount.pid = this.selectedPayment.id
					this.amount.paycon=this.selectedPayment.qrcode
					url = "/pay/createPayUrl";
					Fetch(url,this.amount).then((res)=>{
						if(res.data.code===0){
							Dialog.alert({
							  message: res.data.info,
							  confirmButtonText: window.vm.$i18n.t('utils.confirm')
							}).then(() => {
							  // on close
							});
						}else{
							window.location.href = res.data.payUrl;
						}
					}).finally(()=>{
						this.show=false
					});
					return
				}
				axios.post(url,this.amount)
					.then((res)=>{
						Toast({
						className:"toastName",
						message: this.$t('invest.success')
						});
						this.paydata1= res.data;
						this.paydata = res.data.data;
						console.log("response",res,res.data)
						if (this.paycon == "MEXICO_BANK" && this.paydata.pay_url != null) {
							window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "卡卡-1001" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "大额卡卡-1010" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "支付宝-1002" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "聚合码-1003" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "中通H5-2001" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "快捷-2002" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "CFS-2003" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "韩国银行卡-4001" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else if (this.paycon === "P2P充值-6001" && this.paydata.pay_url != null) {
						  window.location.href = this.paydata.pay_url;
						}else{
							if(res.data.code===0){
								
								Dialog.alert({
								  message: res.data.info,
								  confirmButtonText: window.vm.$i18n.t('utils.confirm')
								}).then(() => {
								  // on close
								});
							}
						}
					}).finally(()=>{
						this.show=false
					});
			},
			// 支付方式
			paymentsta(payment){
				console.log("selected payment:",payment)
				this.selectedPayment = payment;
				const name = payment.name
				this.paycon = name;
				if (this.paycon == "MEXICO_BANK2") {
					this.paylink = "createOrder_QE"
					// this.paystate = "url"
				}else if (this.paycon === "卡卡-1001") {
				  this.paylink = "createOrder_1001";
				}else if (this.paycon === "大额卡卡-1010") {
				  this.paylink = "createOrder_1010";
				}else if (this.paycon === "支付宝-1002") {
				  this.paylink = "createOrder_1002";
				}else if (this.paycon === "聚合码-1003") {
				  this.paylink = "createOrder_1003";
				}else if (this.paycon === "中通H5-2001") {
				  this.paylink = "createOrder_2001";
				}else if (this.paycon === "快捷-2002") {
				  this.paylink = "createOrder_2002";
				}else if (this.paycon === "CFS-2003") {
				  this.paylink = "createOrder_2003";
				}else if (this.paycon === "韩国银行卡-4001") {
				  this.paylink = "createOrder_4001";
				}else if (this.paycon === "P2P充值-6001") {
				  this.paylink = "createOrder_6001";
				}
			},
			// 点击下一步
			submit() {
				this.amount.uid = this.$store.uid;
				this.amount.amounts = this.data.money;
				this.amount.paycon = this.paycon;
				// 充值金额必须满100
				if (!this.amount.amounts || this.amount.amounts < this.config.min_recharge) {
					Toast({
						className:"toastName",
						message: this.$t('invest.rechargeAmountLow') + this.$t('utils.moneyMark') + this.config
						.min_recharge + this.$t('invest.rechargeAmountLow1')
					})
					// 判断uid是否正常获取
				}else if(!this.paycon){
					Toast({
						className:"toastName",
						message: this.$t('invest.paymentMethod')
					})
				}else{
					// 一切顺利正常请求支付
					this.show=true
					this.fetchpay()
				}
			},
		}
	};
</script>

<style lang="less" scoped>
	// 遮罩
	
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
	.canal_tips {
		// padding: 10px 0 20px;
		padding: 5px 15px;
		line-height: 17px;
		font-size: 12px;
		color: #f12211;
	}
	.block {
		width: 120px;
		height: 120px;
		background-color: #fff;
  	}
	.red_top_bg {
		height: 168px;
		background-image: url(../images/user/moneybag/bg.png);
		position: fixed;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.recharge_wrap1 {
		height: 100vh;
		background-image: url(../images/user/moneybag/bg.png);
		background-size: 100% 100%;
		}
	.top_right {
		position: absolute;
		font-size: 13px;
		line-height: 18px;
		color: #FFFFFF;
		top: 36px;
		right: 14px;
	}
	.balance {
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		padding: 15px 0px 25px;
		box-shadow: 2px 2px 5px rgba(115, 115, 115, .35);
		position: absolute;
		top: 74px;
		left: 15px;
		right: 15px;
		text-align: center;
		p:nth-child(1) {
			font-size: 12px;
			color: #999999;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			.van-icon {
				font-size: 20px;
				margin-left: 4px;
				color: #c2c2c2;
			}
		}
		p:nth-child(2) {
			color: #ff5551;
			font-size: 24px;
			font-weight: bold;
		}
	}
	.recharge_cells {
		background-color: #fff;
		padding: 0 15px;
	}
	.recharge_box {
		width: 100%;
		height: 48px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		margin-top: 12px;
		padding: 16px 11px;
		input {
			height: 18px;
			width: 100%;
			line-height: 18px;
			font-size: 14px;
		}
	}
	.form {
		margin-top: 130px;
		.recharge_wrap {
			padding: 0 15px;
			.form-cell {
			    padding: 10px 20px;
			    background: rgba(255, 255, 255, 1);
			    border-radius: 5px;
			    box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
			    display: flex;
			    align-items: center;
			    background-color: #FFF;
			
			    .flex_bd {
			        flex: 1;
			
			        input {
			            height: 40px; /* 增加高度 */
			            width: 100%;
			            line-height: 25px;
			            font-size: 14px;
			            padding: 5px; /* 添加内边距 */
			            border: 1px solid rgba(115, 115, 115, 0.2); /* 添加边框 */
			            border-radius: 4px; /* 圆角 */
			            transition: border-color 0.3s, box-shadow 0.3s; /* 过渡效果 */
			            
			            &:focus {
			                outline: none; /* 去掉默认焦点轮廓 */
			                border-color: #007bff; /* 聚焦时的边框颜色 */
			                box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* 聚焦时的阴影效果 */
			            }
			        }
			    }
			
			    .unit {
			        color: #666666;
			        display: flex;
			        align-items: center;
			        font-size: 12px;
			        font-weight: bold; /* 使用 bold 而不是 bolder */
			        margin-left: 10px; /* 单位与输入框之间的间距 */
			    }
			}
			div:nth-child(2) {
				text-align: right;
				color: #666666;
				margin-top: 8px;
			}
		}
		.tit {
			font-size: 16px;
			padding: 15px;
			color: #333333;
		}
		.item {
		    height: 50px;
		    box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    padding: 10px; /* 添加内边距 */
		    border: 1px solid rgba(115, 115, 115, 0.2); /* 添加边框 */
		    background-color: #f9f9f9; /* 设置背景色 */
		    border-radius: 8px; /* 添加圆角 */
		    transition: background-color 0.3s, box-shadow 0.3s; /* 添加过渡效果 */
		
		    &:last-child {
		        border-bottom: none;
		    }
		
		    &:hover {
		        background-color: #e0e0e0; /* 悬停时的背景色 */
		        box-shadow: 4px 4px 10px rgba(115, 115, 115, 0.5); /* 悬停时的阴影效果 */
		    }
			.re_name {
				font-size: 12px;
				flex: 1;
				line-height: 22px;
				color: #333333;
				margin-left: 4px;
			}
		}
	}
	.sbtn {
		width: 213px;
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		margin: 17px auto;
	}
</style>
